import { Box } from "@chakra-ui/react"
import { AllRoutes } from "../AllRoutes/allRoutes"

function Main(){
    return (
        <Box>
            <AllRoutes/>
        </Box>
    )
}
export {Main}